import React, { useState, useEffect } from 'react';
import BuildAccordion from './BuildAccordion';
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getbuildsheet, getbuildsheetdata, addbuildsheet } from "../../Api/buildsheetApi"
import { getsinglebuildStations, upatebuildStationStatus, upatebuildStatus } from "../../Api/Buildstationsapi"
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { ShippingStGet } from '../../Api/ShippingSt';
import { getbuildStationsfilter, dropdownfilter, getbuilderlist } from '../../Api/Buildstationsapi'
import { useHistory } from 'react-router-dom';

function BuildStationLeft({ buildsheetdataa, allmodels, dropdowndataShipping, BuildStationsss, dropdowndatabuilder, buildsheets, BuildStationdata, remortFittingFormData }) {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const params = useParams();
    const id = params.id;

    const [scrolled, setScrolled] = useState(false);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [buildApiCall, setBuildApiCall] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);
    const [errors, setErrors] = useState([]);
    const [BuildStation, setBuildStation] = useState(0);
    const [userdata, setUserdata] = useState('');
    const [BuildStations, setBuildStations] = useState([]);

    useEffect(() => {
        getBuildStationdata();
        getDataById();
        getbuildSheetDataById();
        getbilderdata();
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

        // dropdownfilter().then((response) => {
        //     if (!response.data.status) {
        //         setErrors(response.data.error);
        //         console.log(response.data.message);
        //     } else {
        //         const data = response.data.data;
        //         setBuildStations(data);
        //     }
        // }).catch((err) => {
        //     console.log(err);
        // }).finally(() => {
        //     setApicall(false);
        // });

        if (BuildStationsss) {
            setBuildStations(BuildStationsss);
        }
        window.scrollTo(0, 0);
    }, []);



    const [selectedButtons, setSelectedButtons] = useState([]);
    const [buildstatus3, setBuildstatus3] = useState(false);


    const [show01, setShow01] = useState(false);

    const handleClose01 = () => setShow01(false);
    const handleShow01 = () => setShow01(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);
    const [closePopup, setClosePopup] = useState('');


    const [buttonNames, setButtonNames] = useState([
        "Driver", "3 Wood", "5 Wood", "7 Wood", "9 Wood", "2 Hybrid",
        "3 Hybrid", "4 Hybrid", "5 Hybrid", "6 Hybrid", "7 Hybrid", "8 Hybrid",
        "1 Iron", "2 Iron", "3 Iron", "4 Iron", "5 Iron", "6 Iron",
        "7 Iron", "8 Iron", "9 Iron", "GW", "SW", "LW", "Putter"
    ]);



    const handleButtonClick = (index, name) => {
        if (selectedButtons.includes(index)) {
            setSelectedButtons(selectedButtons.filter(i => i !== index));
        } else {
            setSelectedButtons([...selectedButtons, index]);
        }

        setButtonNames(buttonNames.filter((_, i) => i !== index));

        const data = {
            builsheetnumber: name,
            project_id: id
        }

        addbuildsheet(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleClose();
                getDataById();
                getbuildSheetDataById();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Assigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('');

    const [isOpen2, setIsOpen2] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState('No Builder');
    const [selectedBuilderid, setSelectedBuilderid] = useState('');
    const [Builderid, setBuilderid] = useState(false);

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const closeDropdown2 = () => {
        setIsOpen2(false);
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option.text);
        setSelectedBuilderid(option._id);
    };

    const [options2, setOptions2] = useState([
        { text: 'No Builder', _id: "0" },
    ]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const selectOption = (option) => {
        setSelectedOption(option.text);
        setselectedOptionsId(option.number)
    };

    const [options, setOptions] = useState();


    const buildStGets = () => {
        // ShippingStGet()
        //     .then((res) => {
        //         console.log("calling api", "1");
        //         const Data = res.data.data;
        //         if (BuildStations) {
        //             const stationStatusArray = BuildStations.map(build => Number(build.station_Id));
        //             console.log("Station Status Array:", stationStatusArray);

        //             const filteredStatusDropdown = Data.filter(
        //                 station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
        //             );
        //             const newOptions = filteredStatusDropdown.map(station => ({
        //                 text: station.Shipping_Stations_name,
        //                 number: Number(station.Shipping_Stations_id),
        //                 color: 'white'
        //             }));
        //             setOptions(prevOptions => [
        //                 { text: 'Assigned', color: 'orange', number: "501" },
        //                 { text: 'Building', color: 'yellow', number: '502' },
        //                 { text: 'Complete', color: 'green', number: '503' },
        //                 { text: 'Verified', color: 'blue', number: '504' },
        //                 ...newOptions
        //             ]);
        //         }
        //     })
        //     .catch((err) => {
        //         alert(err);
        //     });
        if (dropdowndataShipping) {
            setOptions(dropdowndataShipping);
        }
    }

    useEffect(() => {
        buildStGets();
    }, [BuildStations])

    const getDataById = () => {
        // getbuildsheet({ id: id }).then((res) => {
        //     if (res?.code === 200) {
        //         const Data = res.data.data;
        //         setBuildSheetNumber(Data);
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })

        if (buildsheets) {
            setBuildSheetNumber(buildsheets);
        }
    }

    const getbilderdata = () => {
        // getbuilderlist({ id: id }).then((res) => {
        //     if (res?.code === 200) {
        //         const Data = res.data.data;
        //         const newOptions = Data.map(builder => ({
        //             text: builder.fullname,
        //             _id: builder._id,
        //         }));
        //         setOptions2(prevOptions => [
        //             { text: 'No Builder', _id: "0" },
        //             ...newOptions
        //         ]);
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })
        if (dropdowndatabuilder) {
            setOptions2(dropdowndatabuilder);
        }
    }

    const getBuildStationdata = () => {
        // getsinglebuildStations({ project_id: id }).then((res) => {
        //     if (res?.code === 200) {
        //         const Data = res.data.data;
        //         setBuildStation(Data);
        //         setSelectedOption(Data.shipping_station_name);
        //         setselectedOptionsId(Data.shipping_station_Id);
        //         setSelectedOption2(Data.builder_status);
        //         if (Data.builder_id === "0") {
        //             setBuilderid(false);
        //         } else {
        //             setBuilderid(true);
        //         }
        //         if (Data.shipping_station_Id == '501' || Data.shipping_station_Id == '502' || Data.shipping_station_Id == '503' || Data.shipping_station_Id == '504') {
        //             setBuildstatus3(false);
        //         } else {
        //             setBuildstatus3(true);
        //         }
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })

        if (BuildStationdata) {
            setBuildStation(BuildStationdata);
            setSelectedOption(BuildStationdata.shipping_station_name);
            setselectedOptionsId(BuildStationdata.shipping_station_Id);
            setSelectedOption2(BuildStationdata.builder_status);
            if (BuildStationdata.builder_id === "0") {
                setBuilderid(false);
            } else {
                setBuilderid(true);
            }
            if (BuildStationdata.shipping_station_Id == '501' || BuildStationdata.shipping_station_Id == '502' || BuildStationdata.shipping_station_Id == '503' || BuildStationdata.shipping_station_Id == '504') {
                setBuildstatus3(false);
            } else {
                setBuildstatus3(true);
            }
        }
    }

    const getbuildSheetDataById = () => {
        getbuildsheetdata({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetData(Data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])


    const handleupateprojectstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') ? '0' : '1',
            'id': BuildStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "shipping_station_Id": selectedOptionsId,
            "shipping_station_name": selectedOption,
        }
        upatebuildStationStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getBuildStationdata();
                closeDropdown();
                window.location.reload();
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const handleupatebuilderstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': selectedOption2,
            'id': BuildStation._id,
            'project_id': params.id,
            "builder_id": selectedBuilderid,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
        }
        upatebuildStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getBuildStationdata();
                closeDropdown2();
                window.location.reload();
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }


    const [titleModel, settitleModel] = useState("")

    const handleShowBtn = (index, name) => {

        var showname = "";
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        settitleModel(name);

        if (showname === "Driver" || showname === "Wood") {
            handleShow01();
        }

        if (showname === "Hybrid") {
            handleShow3();
        }

        if (showname === "Iron" || showname === "Wedge") {
            handleShow4();
        }

        if (showname === "Putter") {
            handleShow6();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
        }
        handleClose();
    };

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose01();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Hybrid") {
            handleClose3();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Wedge") {
            handleClose5();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Putter") {
            handleClose6();
            getDataById();
            getbuildSheetDataById();
        }

        setClosePopup('');

    }, [closePopup])


    const getColorClass = () => {
        const selectedColor = options.find(opt => opt.text === selectedOption)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };

    useEffect(() => {
        if (buildsheetdataa) {
            setBuildSheetData(buildsheetdataa);
        }
    }, [buildsheetdataa]);

    return (
        <>

            <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">Add Club</h3>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-select-btn'>
                        <div className='select-btn-list'>
                            {buttonNames.map((name, index) => (
                                <div className='select-btn-item' key={index}>
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-select ${selectedButtons.includes(index) ? 'selected' : ''}`}
                                        // onClick={() => handleButtonClick(index,name)}
                                        onClick={() => handleShowBtn(index, name)}
                                    >
                                        {name}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* <div className="build_number_box">
                <div className="build_number_box_inner">
                    <div className="build_title">
                        Build Number
                    </div>
                    <div className="build_number">
                        {buildsheetnumber?.buildnumber || 0}
                    </div>
                </div>
            </div> */}
            <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} selectedOptions={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
            {/* <div className="btn-box-section btn-inline-box"> */}
            {/* <button className="btn btn-primary btn-remove">Remove Build</button> */}
            {/* <button className="btn btn-primary btn-create">Save Build</button> */}
            {/* </div> */}

            {/* Driver + Wood Modal Start Here */}
            <Modal size="lg" show={show01} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{titleModel}</h3>
                            <button type="button" className="btn-close" onClick={handleClose01} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <DriverWood project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Driver + Wood Modal End Here  */}

            {/* Hybrid Modal Start Here */}
            <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{titleModel}</h3>
                            <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Hybrid project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Hybrid Modal End Here  */}

            {/* Iron + Wedge Start Here */}
            <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{titleModel}</h3>
                            <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <IronWedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Iron + Wedge End Here  */}

            {/* Wedge Start Here */}
            <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{titleModel}</h3>
                            <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Wedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Wedge End Here  */}

            {/* Putter Start Here */}
            <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">{titleModel}</h3>
                            <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className="modal-long-form">
                        <Putter project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                    </div>
                </Modal.Body>
            </Modal>
            {/* Putter End Here  */}

            <style>
                {
                    `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                     margin: 0 !important;
                                }
                                `
                }
            </style>
        </>
    );
}

function getbuildStationNumber(stationName) {
    switch (stationName) {
        case "Build Station1":
            return 1;
        case "Build Station2":
            return 2;
        case "Build Station3":
            return 3;
        case "Build Station4":
            return 4;
        default:
            return 0; // or handle other cases as needed
    }
}

export default BuildStationLeft;